import { Component, inject } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
    standalone: false,
    selector: 'por-demo-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
    private readonly loader = inject(LoaderService);

    loading$ = this.loader.loading$;
}
